<template>
  <div class="nav-bar">
    <a href="#">
      <img class="logo-svg" alt="Group 24" src="../assets/group24_logo_colored.svg" />
    </a>
  </div>
</template>

<script>
export default {
  name: "NavigationBar",
}
</script>

<style>
.comp{
  color: white;
}
.nav-bar {
  display: flex;
  justify-content:center;
  background: linear-gradient(to right, rgba(0, 150, 187, 0.75) 0%, rgba(105, 189, 150, 0.75) 100%) !important;
  width: 100vw;
  height: 75px;
  padding: 30px;
}
.logo-svg {
  filter: brightness(0) invert(1);
  height: 60px;
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue